const token = localStorage.getItem("token");
const apiPrefix = `${process.env.REACT_APP_API_URL}/cms/${process.env.REACT_APP_API_VERSION}`;

export function logInUser(email, password) {
  return fetch(`${apiPrefix}/admin/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  }).then((resp) => resp.json());
}

export function editArticle(id, body) {
  return fetch(`${apiPrefix}/newsfeed/item?id=${id}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  })
    .then((resp) => resp.json())
    .then((resp) => resp);
}

export function getArticle(id) {
  return fetch(`${apiPrefix}/newsfeed/item?id=${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((resp) => resp.json())
    .then((resp) => resp);
}

export function postArticle(body) {
  return fetch(`${apiPrefix}/newsfeed/item`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  })
    .then((resp) => resp.json())
    .catch((err) => err.message);
}

export function updateArticleState(id, state) {
  return fetch(`${apiPrefix}/newsfeed/item?id=${id}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ state }),
  })
    .then((resp) => resp.json())
    .then((resp) => resp);
}

export function getNewsfeedSummary(setArticles) {
  console.log('newsfeed summ', token)
  return fetch(
    `${process.env.REACT_APP_API_URL}/cms/${process.env.REACT_APP_API_VERSION}/newsfeed/summary`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((resp) => resp.json())
    .then((arr) => setArticles(arr));
}
